export default __webpack_public_path__ + "static/media/ButtonValidBirds.c54ad0ad.png";